import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const otp = 'api/otp';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

/**
 * 取得要進行OTP驗證的行動電話號碼，取得新舊兩個值
 * @return {Object} beforeMobile/mobile
 * beforeMobile 變更前的要保人行動電話，若為空值代表本次變更沒有異動要保人行動電話
 * mobile 變更後的要保人行動電話
 */
export function getInfoOTP() {
    return get(`${otp}/info`);
}

/**
 * 驗證OTP驗證碼
 * @param {String} otpCode 驗證碼
 * @param {String} mobile 接收OTP驗證碼的手機
 */
export function postVerifyOTP(otpCode, mobile) {
    return post(`${otp}/verify`, { otpCode, mobile });
}

/**
 * 發送OTP驗證碼
 * @param {Boolean} forceSend 若有發現該手機門號有其他人使用，是否要繼續傳送，true=繼續傳送，false=不傳送
 * @param {String} mobile 接收OTP驗證碼的手機
 */
export function postSentOTP(forceSend, mobile) {
    return post(`${otp}/send`, { forceSend, mobile }, { ...options, errorDialog: false, repeatRequestCancel: true });
}

// 重新發送OTP驗證碼
export function postResentOTP() {
    return post(`${otp}/resend`, null, { ...options, errorDialog: false, repeatRequestCancel: true });
}
